import { Stack, Typography } from '@mui/material'
import { FC } from 'react'
import type { FarmQuantificationUnit, ToGeoJSON } from '@/types/apiModels'
import { StratificationQUsAccordion } from './accordion/StratificationQUsAccordion'

type StratificationQUsYearGroupProps = {
  year: string
  qus: FarmQuantificationUnit[]
  samplingAreas: ToGeoJSON[]
  hiddenSamplingAreaQUIds: ReadonlySet<string>
  onToggleSamplingAreasVisibility: (quId: string) => void
}

export const StratificationQUsYearGroup: FC<StratificationQUsYearGroupProps> = ({
  year,
  qus,
  samplingAreas,
  hiddenSamplingAreaQUIds,
  onToggleSamplingAreasVisibility,
}) => {
  return (
    <Stack spacing={1}>
      <Stack spacing={0.25}>
        <Typography variant="h6">{year}</Typography>
        <Typography color="text.secondary" variant="caption">
          Año 1 de proyecto
        </Typography>
      </Stack>
      {qus.map(qu => (
        <StratificationQUsAccordion
          key={qu.id}
          isSamplingAreasVisible={!hiddenSamplingAreaQUIds.has(qu.id)}
          qu={qu}
          samplingAreas={samplingAreas}
          onToggleSamplingAreasVisibility={onToggleSamplingAreasVisibility}
        />
      ))}
    </Stack>
  )
}
